// Generated by `pnpm generate` — do not edit.
import { createIcon } from '../create-icon';

export const ShieldIcon = /* @__PURE__ */ createIcon(
  'shield',
  { fill: 'none', viewBox: '0 0 24 24' },
  [
    [
      'path',
      {
        fill: 'currentColor',
        d: 'M19 7.253c0-.882-.016-1.057-.065-1.188a1 1 0 0 0-.274-.394c-.105-.093-.264-.169-1.089-.478l-5.361-2.01-.208-.077h-.006l-.208.076-5.361 2.011c-.825.31-.984.385-1.09.478a1 1 0 0 0-.273.394c-.05.13-.065.306-.065 1.188v4.782c0 2.082 1.14 3.965 2.642 5.53 1.49 1.553 3.228 2.676 4.164 3.222l.194.11.06-.033.134-.077c.936-.546 2.673-1.668 4.164-3.222C17.861 16 19 14.117 19 12.035zm2 4.782c0 2.826-1.537 5.184-3.2 6.915-1.672 1.742-3.586 2.973-4.598 3.563-.19.111-.442.269-.783.342a2.1 2.1 0 0 1-.838 0c-.341-.073-.593-.23-.783-.342-1.012-.59-2.926-1.82-4.599-3.563C4.537 17.219 3 14.862 3 12.035V7.253c0-.718-.016-1.342.196-1.899a3 3 0 0 1 .82-1.183c.448-.394 1.038-.599 1.71-.851l5.36-2.01c.169-.064.39-.152.628-.186a2 2 0 0 1 .43-.016l.142.016.175.035c.17.042.326.103.452.15l5.361 2.011c.672.252 1.262.457 1.71.85a3 3 0 0 1 .82 1.184c.212.557.196 1.181.196 1.899z',
      },
    ],
  ]
);
